export default function ServiceCta() {
  return (
    <section id="cotizacion" className="py-14 md:py-20 px-4 md:px-8 lg:px-12 bg-[#0087a4] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-40 h-40 rounded-full bg-background-50 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-60 h-60 rounded-full bg-background-50 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center reveal">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4 leading-tight">
          ¿Listo para cotizar tu equipo de climatización?
        </h2>
        <p className="text-white text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          Cuéntanos las características de tu espacio y un ingeniero te recomendará el equipo más eficiente sin costo y sin compromiso.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <a
            href="https://wa.me/573232209100"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3.5 rounded-lg bg-background-50 text-foreground-950 font-semibold text-sm md:text-base hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2" />
            Cotizar por WhatsApp
          </a>
        </div>
        <p className="text-white text-xs mt-5">
          Samsung · LG · Midea · Mabe · Mirage · Garantía de fábrica incluida
        </p>
      </div>
    </section>
  );
}